import React from 'react';

import { BrowserRouter } from 'react-router-dom';

import { TypeApplicationStore } from '@stores/application-store';
import { injectStores } from '@stores/factories/store-utils';

import Footer from '../components/menus/footer/footer';

import './jakhub.scss';

export interface Props {
    ApplicationStore: TypeApplicationStore;
}

function Jakhub(props: Props) {
    const {
        ApplicationStore: { applicationIsLoaded },
    } = props;

    if (!applicationIsLoaded()) {
        return <div />;
    }

    return (
        <BrowserRouter>
            <Footer />
        </BrowserRouter>
    );
}

export default injectStores(['ApplicationStore'])(Jakhub);
